module.exports = __webpack_public_path__ + "img/icon-promo-marketing.7489b52f.svg";